import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { CustomerEditParams, CustomerEditGet } from '@app/services/customer.service';

@Component({
    selector: 'tt-customer-edit-view',
    templateUrl: './customer-edit-view.component.html',
    styleUrls: ['./customer-edit-view.component.css'],
})
export class CustomerEditViewComponent {
    public params: CustomerEditParams;

    public heading = '';

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as CustomerEditParams;
    }

    public onGetLoaded(event: CustomerEditGet) {
        this.heading = event.webpage_heading;
    }

    public onSubmit(event: CustomerEditGet & { addContactsAfterNewCustomer: boolean }) {
        if (event.autosave === '1') return;

        if (window.location.href.includes('?ispopup')) {
            window.opener.postMessage({
                type: 'ttData',
                data: { cust_no: event.cust_no, cust_name: event.cust_name },
            });

            setTimeout(() => {
                window.close();
            });
        } else {
            if (event.addContactsAfterNewCustomer) {
                this.state.go('customerpersons', { cust_no: event.cust_no, new_customer: true });
            } else {
                this.state.back();
            }
        }
    }
}
